import { atomWithReset } from 'jotai/utils';

import type { Organization } from './types';

export const initialState = (): Organization | null => null;

export const meOrgState = atomWithReset<Organization | null>(initialState());
